"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Payout_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payout = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const DateRange_1 = require("./DateRange");
const AVAILABLE_GATEWAY_ID_PAYOUT_TYPES = [legacy_enums_1.PayoutType.Mangopay, legacy_enums_1.PayoutType.Hyperwallet];
let Payout = Payout_1 = class Payout {
    _id = (0, uuid_1.v4)();
    createdAt = new Date();
    period;
    userId;
    amount = 0;
    customAmount = 0;
    customDescription;
    currency = legacy_enums_1.Currency.Euro;
    type;
    description;
    transferGatewayIds;
    payoutGatewayId;
    fulfilledAt;
    failedAt;
    unknownAt;
    processingAt;
    approvedAt;
    approvedByUserId;
    declinedAt;
    latestWebhookNotificationDate;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Payout_1, legacy_enums_1.PayoutStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.PayoutStatus.Failed:
                return {
                    failedAt: defined,
                    fulfilledAt: undefined,
                };
            case legacy_enums_1.PayoutStatus.Fulfilled:
                return {
                    failedAt: undefined,
                    fulfilledAt: defined,
                };
            case legacy_enums_1.PayoutStatus.Unknown:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                    unknownAt: defined,
                };
            case legacy_enums_1.PayoutStatus.Approved:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                    declinedAt: undefined,
                    processingAt: undefined,
                    approvedAt: defined,
                };
            case legacy_enums_1.PayoutStatus.Declined:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                    declinedAt: defined,
                };
            case legacy_enums_1.PayoutStatus.Processing:
                return {
                    fulfilledAt: undefined,
                    failedAt: undefined,
                    approvedAt: defined,
                    processingAt: defined,
                };
            case legacy_enums_1.PayoutStatus.Pending:
            default:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                    unknownAt: undefined,
                    approvedAt: undefined,
                    declinedAt: undefined,
                };
        }
    }
};
exports.Payout = Payout;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payout.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DateRange_1.DateRange),
    __metadata("design:type", DateRange_1.DateRange)
], Payout.prototype, "period", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payout.prototype, "userId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Payout.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Payout.prototype, "customAmount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((payout) => payout.customAmount !== 0),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payout.prototype, "customDescription", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Payout.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Payout.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.type === legacy_enums_1.PayoutType.Other),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payout.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)()
    // only Mangopay can have transfer ids since we are paying out with mangopay (thru the system)
    ,
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Payout.prototype, "transferGatewayIds", void 0);
__decorate([
    (0, typeorm_1.Column)()
    // only Mangopay and Hyperwallet can have gateway id
    ,
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => AVAILABLE_GATEWAY_ID_PAYOUT_TYPES.includes(p.type) && p.status === legacy_enums_1.PayoutStatus.Fulfilled),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payout.prototype, "payoutGatewayId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "fulfilledAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "failedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "unknownAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "processingAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "approvedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payout.prototype, "approvedByUserId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payout.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Payout.prototype, "latestWebhookNotificationDate", void 0);
exports.Payout = Payout = Payout_1 = __decorate([
    (0, typeorm_1.Entity)("payouts")
], Payout);
//# sourceMappingURL=Payout.js.map